/**
 * Fechas sin hora, como la de emision del certificado.
 *
 * Se arman y se leen en UTC a proposito. "2026-03-15" no tiene hora: si se la
 * pasa por la zona horaria de quien mira, en toda America se convierte en
 * medianoche del dia anterior y la pantalla muestra el 14. Fijar UTC en las
 * dos puntas deja la fecha quieta.
 *
 * Acepta tanto "2026-03-15" como una ISO completa, porque segun la consulta
 * el backend puede devolver cualquiera de las dos.
 */

const PATRON_ISO = /^\d{4}-\d{2}-\d{2}$/;

/** Deja el valor listo para un <input type="date">, o "" si no es una fecha. */
export const paraInputDate = (valor) => {
  const iso = String(valor ?? "").slice(0, 10);
  return PATRON_ISO.test(iso) ? iso : "";
};

/** "2026-03-15" -> "Mar 15, 2026". Devuelve null si no hay fecha. */
export const formatoFechaSimple = (valor) => {
  const iso = paraInputDate(valor);
  if (!iso) return null;

  const [anio, mes, dia] = iso.split("-").map(Number);
  return new Date(Date.UTC(anio, mes - 1, dia)).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "2-digit",
    timeZone: "UTC",
  });
};

/**
 * Hoy en UTC, para el `max` de un input de fecha.
 *
 * En UTC igual que el backend, para que el calendario no ofrezca un dia que
 * el servidor va a rechazar por futuro.
 */
export const hoyISO = () => new Date().toISOString().slice(0, 10);
